import websiteGlobalBricks from './website-globals';
import reviewsBrick from './reviews';

export const BRICKS = [
    ...websiteGlobalBricks,
    reviewsBrick
];

export const getBrickById = (id) => {
    if (!id) return null;
    return BRICKS.find(brick => brick.id === id) || null;
};

export const matchBrickByToken = (token) => {
    for (const brick of BRICKS) {
        const result = brick.matchToken?.(token);
        if (result) return result;
    }
    return null;
};
